import React from 'react';
import './generic-style.scss';
import { Button, Input, Select, Checkbox, Icon, Tag } from 'antd';
import classnames from 'classnames';
import CloudFlyerAPI from '../../../api/CloudFlyerAPI';

let validate = field => field !== undefined && field.length === 0

export default class AddAwsSteps extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openAdvanceSettings : false
        }
    }

    // handleSave = id => {
    //     const { receiveId } = this.props
    //     receiveId(id)
    // }

    // startSaving = () => {}
    openAdvanceSettingsHandler = () =>{
        console.log(this.state.openAdvanceSettings);
        let value = !this.state.openAdvanceSettings;
        this.setState ({openAdvanceSettings:value})
    }


    render() {
        const {
            disabled,
            edit,
            setupForm,
            loading,
            storages,
            billing_bucket,
            on_save,
            on_input_change,
            on_billing_bucket_change,
            openAdvanceSettings
        } = this.props

        let providers = [
            {
                id: 1,
                name: 'aws',
                // img: AmazonS3Logo,
                enabled: true,
            },
            {
                // img: WasabiLogo,
                id: 2,
                name: 'wasabi',
                enabled: true,
            },
            {
                // img: AzureLogo,
                id: 3,
                name: 'azure',
                enabled: true,
            },
            {
                // img: BackblazeLogo,
                id: 4,
                name: 'backblaze',
                enabled: true
            },
            {
                // img: GenericS3Logo,
                id: 5,
                name: 'genericS3',
                enabled: true

            }
        ]
        
        let signatureVersion =[
            {
                id:1,
                name: "Signature V2"
            },
            {
                id:2,
                name: "Signature V4"
            }
        ]


        // const { saving } = this.state

        return (
            <div className={'add-generic'}>
                <h3>On-board existing account</h3>
                <div className="input-area">
                    <div className="left-pannel">
                        <div>
                            <label>API Key*</label>
                            <Input
                                placeholder="enter api key"
                                name="access_key_id"
                                value={setupForm.access_key_id}
                                disabled={edit}
                                className={classnames({
                                    required: validate(setupForm.access_key_id),
                                })}
                                onChange={on_input_change}
                            />
                            {validate(setupForm.access_key_id) && (
                                <span className="required">Field is required.</span>
                            )}
                        </div>

                        <div>
                            <label>Secret*</label>
                            <Input
                                type={edit ? 'password' : 'text'}
                                placeholder="enter api secret"
                                name="secret_access_key"
                                value={setupForm.secret_access_key}
                                disabled={edit}
                                className={classnames({
                                    required: validate(setupForm.secret_access_key),
                                })}
                                onChange={on_input_change}
                            />
                            {validate(setupForm.secret_access_key) && (
                                <span className="required">Field is required.</span>
                            )}
                        </div>

                    </div>

                    <div className="right-pannel">
                    <div>
                            <label>URL(Generic S3 endpoint)*</label>
                            <Input
                                placeholder="https://s3.example.com or http://s3.example.com"
                                name="endpoint"
                                value={setupForm.endpoint}
                                // disabled={edit}
                                className={classnames({
                                    required: validate(setupForm.endpoint),
                                })}
                                onChange={on_input_change}
                            />
                            {validate(setupForm.access_key_id) && (
                                <span className="required">Field is required.</span>
                            )}
                        </div>

                        <div>
                            <label>Give it a name*</label>
                            <Input
                                placeholder="enter account name"
                                name="project_name"
                                value={setupForm.project_name}
                                className={classnames({
                                    required: validate(setupForm.secret_access_key),
                                })}
                                onChange={on_input_change}
                            />
                            {validate(setupForm.project_name) && (
                                <span className="required">
                                    It's always good to give a name to your cloud
                                    service, so you can organize them better.
                                </span>
                            )}
                        </div>

                        {/* <div className="provider-selector">
                            <label>Select Generic S3</label>
                            <Select
                                // value="Select a Provider"
                                placeholder="Select a Provider"
                                // onChange={e =>
                                //     this.on_cloud_change('left', e)
                                // }
                                // disabled={
                                //     left_clouds_selection_disabled
                                // }
                                size={'large'}
                                // dropdownMatchSelectWidth={false}
                                className={'transfer-select'}>
                                {providers.map((p, index) => (
                                    <Select.Option
                                        key={index}
                                        value={p.id}>
                                        {p.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </div>

                        <div className="secure-transfer">
                            <div className="checkBox-area">
                                <Checkbox />
                            </div>
                            <label>Use Secure Transfer (SSL/TLS)</label>
                        </div>   
                        <div>
                            <a onClick={this.openAdvanceSettingsHandler} >Advanced Settings</a>
                        </div> */}
                    </div>
                </div>

                <div className="footer">
                    <Button
                        type="primary"
                        disabled={disabled}
                        loading={loading}
                        onClick={() => {
                            on_save(this.handleSave)
                        }}>
                        Apply
                    </Button>
                </div>

                {/* advanced-settings-area  */}
                <div className={this.state.openAdvanceSettings ? "advanced-settings-area":"hidden"} >
                    <div className="signature-version-wrapper">
                        <label>Signature Version</label>
                        <Select
                            defaultValue={signatureVersion[0].name}
                            size={'large'}
                            className={'transfer-select'}>
                            {signatureVersion.map((p, index) => (
                                <Select.Option
                                    key={index}
                                    value={p.id}>
                                    {p.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>

                    <div className="storage-region-wrapper">

                        <div className="secure-transfer">
                            <div className="checkBox-area">
                                <Checkbox />
                            </div>
                            <label>Storage {'{'} region-code {'}'} variable</label>
                        </div>   

                        <div className="region-codes-input">
                            <Select
                                mode="tags" open={false} size={'large'}
                                placeholder="us-east-01,us-west-01" 
                                tokenSeparators={[',', ' ']}
                                className="region-text-textarea"
                            />
                        </div>

                        <p>You may define custome region here using comma separator (,) . format is: region-code. Example: us-east-01,us-west-01</p>

                    </div>
                    
                    <div className="storage-endpoint-wrapper">
                        <label>Storage-specific endpoint (optional)</label>
                        <div className="region-endpoit-input">
                            <textarea
                            // className="slack-text"
                            placeholder="s3. { region-code }.wasabisys.com" 
                            // value=""
                            // onChange={}
                            // onKeyDown={}
                            />
                        </div>
                        <p>Specify endpoint using the {'{'} region-code {'}'} variable, for example s3. {'{'} region-code{'}'}.wasabisys.com</p>

                    </div>
                    <div className="advanced-settings-footer">
                        <Button
                            type="primary"
                            disabled={disabled}
                            loading={loading}
                            onClick={on_save}>
                            Save
                        </Button>
                    </div>



                    
                </div>


            </div>
            
        )
    }
}
